<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div class="container-fluid">
  <app-topbar></app-topbar>
  <div *notAllowedPermissions="['incompleteLogin']" class="d-flex mt-4">
    <app-side-bar class="app-side-bar"></app-side-bar>
    <div #sectionNeedToScroll class="w-100" id="layout-main">
      <nav *ngIf="breadcrumbs.length" class="navbar navbar-expand navbar-light bg-light mb-3 nav-style"
           id="breadcrumb-sf-1">
        <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
          <ol class='breadcrumb ol-nav'>
            <li *roles="['ROLE_MCKAY']"><a routerLink="/mckay/{{getUserCurrent().company.uniqid}}"> Home </a></li>
            <li *roles="['ROLE_CLIENT']"><a routerLink="/client/{{getUserCurrent().company.uniqid}}"> Home </a></li>
            <li *ngFor='let breadcrumb of breadcrumbs'>
              <a *ngIf="!breadcrumb.isLast" [routerLink]='[breadcrumb.url]'
                 routerLinkActive='active'>&nbsp;/ {{ breadcrumb.title }} </a>
              <span *ngIf="breadcrumb.isLast">&nbsp;/ {{ breadcrumb.title }} </span>
            </li>
          </ol>
        </nav>
      </nav>
      <router-outlet *ngIf="authenticationService.userAuthenticated"></router-outlet>
    </div>
  </div>

  <ng-container *notAllowedPermissions="['incompleteLogin', 'mustSetupAuthenticator']">
    <footer *ngIf="authenticationService.userAuthenticated">
      <hr class="my-4">
      <p> © McKay Brothers, LLC-Confidential-All Rights Reserved {{ this.year | date : 'y' }} -
        <a [target]="'_blank'" [href]="privacyPolicyUrl">Privacy Policy</a></p>
    </footer>
  </ng-container>
</div>
<p-dialog [blockScroll]="true" [closable]="false" [closeOnEscape]="false" [maximizable]="false" [modal]="true"
          [responsive]="true"
          (onShow)="onDialogShow()"
          [style]="{width: '500px', 'min-height': '450px'}" [visible]="isMfa()">
  <ng-template *ngIf="!isResetPasswordPage() && !isNewUserConfirmationPage() && !isNewEmailConfirmationPage()"
               pTemplate="header">
    Two-Factor Authentication Required
    <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
  </ng-template>
  <app-mfa *ngIf="isMfa()"></app-mfa>
</p-dialog>

<p-dialog [blockScroll]="true" [closable]="false" [closeOnEscape]="false" [maximizable]="false" [modal]="true"
          [responsive]="true"
          [visible]="mfaSetup()">
  <ng-template *ngIf="!isResetPasswordPage() && !isNewUserConfirmationPage() && !isNewEmailConfirmationPage()"
               pTemplate="header"
               style="background-color: transparent;">
    Two-Factor Authentication Setup
    <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
  </ng-template>
  <app-authentication-setup *ngIf="mfaSetup()"></app-authentication-setup>
</p-dialog>

<div class="login">
  <p-dialog (visibleChange)="authenticationService.userAuthenticated = $event"
            [blockScroll]="true"
            [closable]="false" [closeOnEscape]="false" [maximizable]="false" [modal]="true" [responsive]="true"
            [style]="{width: '500px', 'min-height': '450px'}" [visible]="!authenticationService.userAuthenticated"
            styleClass="dialog-auth">
    <ng-template *ngIf="!isResetPasswordPage() && !isNewUserConfirmationPage() && !isNewEmailConfirmationPage()"
                 pTemplate="header">You are not authenticated yet &nbsp;
      <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
    </ng-template>
    <ng-template *ngIf="isResetPasswordPage()" pTemplate="header">Reset password &nbsp;
      <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
    </ng-template>
    <ng-template *ngIf="isNewUserConfirmationPage()" pTemplate="header">User Confirmation &nbsp;
      <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
    </ng-template>
    <ng-template *ngIf="isNewEmailConfirmationPage()" pTemplate="header">Email Confirmation &nbsp;
      <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
    </ng-template>
    <app-reset-password *ngIf="isResetPasswordPage() || isNewUserConfirmationPage()"></app-reset-password>
    <app-email-change-confirmation *ngIf="isNewEmailConfirmationPage()"></app-email-change-confirmation>
    <app-login
      *ngIf="authenticationService.isLoginMode && !isResetPasswordPage() && !isNewUserConfirmationPage() && !isNewEmailConfirmationPage()"></app-login>
    <app-forgot-password
      *ngIf="!authenticationService.isLoginMode && !isResetPasswordPage() && !isNewUserConfirmationPage() && !isNewEmailConfirmationPage()"></app-forgot-password>
  </p-dialog>
</div>

<p-toast>
  <ng-template let-message pTemplate="message">
    <div class="p-toast-message-content without-default-icon">
      <div class="p-toast-message-text">
        <span class="p-toast-summary">{{ message.summary }}</span>
        <div class="p-toast-detail">{{ message.detail }}</div>
        <a *ngIf="message.data?.viewCartLink" class="toast-link" (click)="navigateToCartFromToast(message.id)">View Cart</a>
      </div>
      <button *ngIf="!message.data?.disableCustomClose" type="button" class="p-toast-icon-close pi pi-times"
              (click)="messageService.clear(message.id)"></button>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog header="Confirmation" width="600"></p-confirmDialog>

<p-dialog [(visible)]="utilsService.simpleMessageData.isVisible" [modal]="true" [showHeader]="true">
  <ng-template pTemplate="header">
    <span [innerHtml]="utilsService.simpleMessageData.header"></span>
  </ng-template>
  <div [innerHtml]="utilsService.simpleMessageData.message"></div>
  <ng-template pTemplate="footer">
    <button (click)="utilsService.simpleMessageData.isVisible = false"
            [label]="utilsService.simpleMessageData.buttonLabel" icon="pi pi-check" pButton
            type="button"></button>
  </ng-template>
</p-dialog>
